module.exports = __webpack_public_path__ + "static/img/5206_phase_function_Paper_PointsHejduk_Prediction.b7db405.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5206_phase_function_Paper_PointsHejduk_Prediction.png
// module id = rHjW
// module chunks = 0